import { LoginFunction } from 'components/providers/loginContext';
import { ENDPOINT_TOKEN } from 'constants/constants';
import { getAPI, postAPI } from 'utils/commonService';

export type ExitToken = {
  exitToken: boolean;
};

export type RsiTokenResponse = {
  accessToken: string;
  refreshToken: string;
  role: string[];
};

export type RsiAuthorizeParameter = {
  redirectUri: string;
  code: string;
};

// ログインユーザーのテナントのリフレッシュトークンを取得する
export async function getToken(
  loginContext: LoginFunction,
): Promise<ExitToken> {
  return (await getAPI(ENDPOINT_TOKEN, loginContext)) as ExitToken;
}

// ログインユーザーのテナントのリフレッシュトークンをAWSパラメータストアに登録する
export async function registerToken(
  loginContext: LoginFunction,
  rsiAuthorizeParameter: RsiAuthorizeParameter,
): Promise<void> {
  const body = rsiAuthorizeParameter;
  return await postAPI(ENDPOINT_TOKEN, loginContext, body);
}
